import PQueue from 'p-queue'
import { useQuery } from 'react-query'
import { normalizeAssetUrl } from '@/helpers/normalizeAssetUrl'
import { preloadImage } from '@/helpers/preloadImage'

/**
 * 预加载图片
 * @param {object} options
 * @param {string[]} options.images 要预加载图片列表
 * @param {number} [options.concurrency] 同时处理的图片个数
 * @param {number} [options.cacheTime] 缓存时长（默认不缓存）
 */
export function usePreloadImages({ images, concurrency = 4, cacheTime = 0 }) {
  return useQuery(
    ['preload-images', { images, concurrency }],
    async () => {
      const queue = new PQueue({ concurrency })
      for (const image of images) {
        queue.add(() => preloadImage(normalizeAssetUrl(image)))
      }
      await queue.onIdle()
    },
    {
      enabled: images.length > 0,
      retry: true,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      cacheTime,
    },
  )
}
